/**
 * A random id for one event or one device.
 *
 * crypto.randomUUID needs a secure context and a recent browser; the fallback keeps the tracker
 * working everywhere rather than throwing on the one browser that lacks it. Both forms stay inside
 * the character set the backend accepts for ids: [A-Za-z0-9._-].
 */
export const createRandomId = (): string => {
  try {
    const { crypto } = window

    if (crypto && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID()
    }
  } catch (error) {
    // Fall through to the non-crypto id below.
  }

  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}
